module.exports = __webpack_public_path__ + "img/pdf_brain_network.bd0e0b1c.jpg";